import { render, staticRenderFns } from "./SwiperDepartment.vue?vue&type=template&id=02d963cd&"
import script from "./SwiperDepartment.vue?vue&type=script&lang=js&"
export * from "./SwiperDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports